<template>
  <div v-if="loadComponent">
    <v-form>
      <v-container>
        <h1>Seminars and Trainings</h1>
        <emp-image :empCode="selectedEmp.code"></emp-image>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-radio-group v-model="formatType" row :class="classPadding">
              <v-radio label="Individual" value="indi"></v-radio>
              <v-radio label="Batch" value="batch"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <div v-if="formatType == 'indi'">
          <v-alert type="warning" v-if="selectedEmp.remarks != null">
            {{ selectedEmp.remarks }}
          </v-alert>
        </div>

        <v-row>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            md="4"
            :class="classPadding"
            v-if="formatType == 'indi'"
          >
            <emp-lookup
              :class-padding="classPadding"
              v-model="selectedEmp"
              label="Employee Code"
              title="Employee"
              :code-value="true"
              :required="true"
            ></emp-lookup>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            md="8"
            :class="classPadding"
            v-if="formatType == 'indi'"
          >
            <v-text-field autocomplete="off"
              label="Name"
              :value="selectedEmp.desc"
              :class="classPadding"
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <seminar-lookup
              :class-padding="classPadding"
              v-model="selectedSeminar"
              label="Seminar Title "
              title="Seminar Title/Course"
              :required="true"
            ></seminar-lookup>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-text-field autocomplete="off"
              label="Training Classification"
              :class="classPadding"
              v-model="selectedSeminar.semClassDesc"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-text-field autocomplete="off"
              label="Training /Seminar Type"
              :class="classPadding"
              v-model="selectedSeminar.semTypeDesc"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <custom-datepicker
              :class-padding="classPadding"
              label="Date From"
              v-model="model.dateFrom"
              :required="true"
            ></custom-datepicker>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <custom-datepicker
              :class-padding="classPadding"
              label="Date To"
              v-model="model.dateTo"
              :required="true"
            ></custom-datepicker>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-text-field autocomplete="off"
              label="Hours/Day"
              :class="classPadding"
              v-model="model.hours"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-text-field autocomplete="off"
              label="Cost"
              :class="classPadding"
              v-model="model.cost"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-text-field autocomplete="off"
              label="Remarks"
              :class="classPadding"
              v-model="model.remarks"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-text-field autocomplete="off"
              label="Venue"
              :class="classPadding"
              v-model="model.venue"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-text-field autocomplete="off"
              label="Provider"
              :class="classPadding"
              v-model="model.provider"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-text-field autocomplete="off"
              label="Duration"
              :class="classPadding"
              v-model="model.duration"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-text-field autocomplete="off"
              label="Time From"
              type="time"
              :class="classPadding"
              v-model="model.timeFrom"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-text-field autocomplete="off"
              label="Time To"
              type="time"
              :class="classPadding"
              v-model="model.timeTo"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-text-field autocomplete="off"
              label="Relation"
              :class="classPadding"
              v-model="model.relation"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-text-field autocomplete="off"
              label="No. of Months"
              :class="classPadding"
              v-model="model.monthNo"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-text-field autocomplete="off"
              label="Submitted Req. Ref #"
              :class="classPadding"
              v-model="model.reqRefNo"
            >
              <template slot="append">
                <span class="required">*</span>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="3" :class="classPadding">
            <v-checkbox
              label="With Contract"
              :class="classPadding"
              v-model="model.withContract"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="3" :class="classPadding">
            <v-checkbox
              label="Organization Sponsor"
              :class="classPadding"
              v-model="model.orgSponsor"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="3" :class="classPadding">
            <v-checkbox
              label="Company Sponsored"
              :class="classPadding"
              v-model="model.compSponsor"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            md="6"
            :class="classPadding"
            v-if="formatType == 'indi' && !showViewAttachment"
          >
            <v-file-input
              label="Attachment"
              :class="classPadding"
              v-model="attachment"
            ></v-file-input>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-select
              label="Rating"
              :class="classPadding"
              :items="ratings"
              item-text="text"
              item-value="value"
              v-model="model.ratings"
            ></v-select>
          </v-col>
        </v-row>
        <v-row v-if="formatType == 'batch'">
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <emp-selection
              :show-dense="false"
              :show-select="true"
            ></emp-selection>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn
              color="success"
              :loading="isSaving"
              :class="classPadding"
              @click.stop="save"
              v-if="userAccess.add >= 1"
              >Add</v-btn
            >
          </v-col>
        </v-row>
        <v-row v-if="showViewAttachment">
          <v-col cols="12" xs="12" sm="12" md="12">
            <a @click.prevent="openAttachment">View Attachment</a>
          </v-col>
        </v-row>
        <v-row v-if="formatType == 'indi'">
          <v-col>
            <list :emp-code="selectedEmp.code" :key="componentKey">
              <template slot="actions" slot-scope="{ item }">
                <v-btn
                  @click.stop="edit(item)"
                  text
                  icon
                  v-if="userAccess.edit >= 1"
                >
                  <v-icon color="primary">mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  @click.stop="deleteItem(item)"
                  text
                  icon
                  v-if="userAccess.delete >= 1"
                >
                  <v-icon color="error">mdi-delete</v-icon>
                </v-btn>
              </template>
              <template slot="attachment" slot-scope="{ item }">
                <v-btn @click.stop="viewAttachment(item)" text outlined
                  >View</v-btn
                >
              </template>
            </list>
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-dialog v-model="editDialog" width="700" persistent scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">Edit</span>
        </v-card-title>
        <v-card-text>
          <br />
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <seminar-lookup
                :class-padding="classPadding"
                v-model="editSelectedSeminar"
                label="Seminar Title "
                title="Seminar Title/Course"
                :required="true"
              ></seminar-lookup>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <v-text-field autocomplete="off"
                label="Training Classification"
                :class="classPadding"
                v-model="editSelectedSeminar.semClassDesc"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <v-text-field autocomplete="off"
                label="Training /Seminar Type"
                :class="classPadding"
                v-model="editSelectedSeminar.semTypeDesc"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <custom-datepicker
                :class-padding="classPadding"
                label="Date From"
                v-model="editModel.dateFrom"
                :required="true"
              ></custom-datepicker>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <custom-datepicker
                :class-padding="classPadding"
                label="Date To"
                v-model="editModel.dateTo"
                :required="true"
              ></custom-datepicker>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <v-text-field autocomplete="off"
                label="Hours/Day"
                :class="classPadding"
                v-model="editModel.hours"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <v-text-field autocomplete="off"
                label="Cost"
                :class="classPadding"
                v-model="editModel.cost"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <v-text-field autocomplete="off"
                label="Remarks"
                :class="classPadding"
                v-model="editModel.remarks"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <v-text-field autocomplete="off"
                label="Venue"
                :class="classPadding"
                v-model="editModel.venue"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <v-text-field autocomplete="off"
                label="Provider"
                :class="classPadding"
                v-model="editModel.provider"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <v-text-field autocomplete="off"
                label="Duration"
                :class="classPadding"
                v-model="editModel.duration"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <v-text-field autocomplete="off"
                label="Time From"
                type="time"
                :class="classPadding"
                v-model="editModel.timeFrom"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <v-text-field autocomplete="off"
                label="Time To"
                type="time"
                :class="classPadding"
                v-model="editModel.timeTo"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <v-text-field autocomplete="off"
                label="Relation"
                :class="classPadding"
                v-model="editModel.relation"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <v-text-field autocomplete="off"
                label="No. of Months"
                :class="classPadding"
                v-model="editModel.monthNo"
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <v-text-field autocomplete="off"
                label="Submitted Req. Ref #"
                :class="classPadding"
                v-model="editModel.reqRefNo"
              >
                <template slot="append">
                  <span class="required">*</span>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="3" :class="classPadding">
              <v-checkbox
                label="With Contract"
                :class="classPadding"
                v-model="editModel.withContract"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="3" :class="classPadding">
              <v-checkbox
                label="Organization Sponsor"
                :class="classPadding"
                v-model="editModel.orgSponsor"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="3" :class="classPadding">
              <v-checkbox
                label="Company Sponsored"
                :class="classPadding"
                v-model="editModel.compSponsor"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
              <v-file-input
                label="Attachment"
                :class="classPadding"
                v-model="attachment"
              ></v-file-input>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <v-select
                label="Rating"
                :class="classPadding"
                :items="ratings"
                item-text="text"
                item-value="value"
                v-model="editModel.ratings"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click.stop="editDialog = false"
            >Close</v-btn
          >
          <v-btn
            text
            color="success"
            @click.stop="update"
            :loading="isUpdating"
            v-if="userAccess.update >= 1"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import EmpLookup from "../../employee-masterfile/personal-info/Lookup";
import EmpSelection from "../../employee-masterfile/personal-info/Selection";
import CustomDatepicker from "../../../../components/CustomDatepicker";
import SeminarLookup from "../../../setup/employment-other-info/course-seminar/seminar-course/Lookup";
import List from "./List";
import { viewFileWithLocation } from "../../../../helpers/utility";
import moment from "moment";
import EventBus from "../../../../events/eventBus";
import { mapState, mapActions } from "vuex";
import { isNullOrUndefined } from "../../../../validation/validation";
import selectEmpMixin from "../../employee-masterfile/personal-info/mixins/selectEmpMixin";
import EmpImage from "../../employee-masterfile/personal-info/Image";
import userAccessMixin from "../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/seminarTraining";
const FOLDER_NAME = "seminarTraining";
export default {
  metaInfo: {
    title: "Seminars and Trainings",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [selectEmpMixin, userAccessMixin],
  data: () => ({
    model: {
      date: new Date().toISOString()
    },
    classPadding: "my-0 py-0",
    selectedEmp: {},
    dateModel: null,
    selectedSeminar: {},
    editSelectedSeminar: {},
    isSaving: false,
    componentKey: 0,
    editModel: {},
    editDialog: false,
    attachment: null,
    attachmentDialog: false,
    attachmentImage: null,
    isUpdating: false,
    formatType: "indi",
    ratings: [
      {
        text: "Pass",
        value: "Pass"
      },
      {
        text: "Failed",
        value: "Failed"
      }
    ],
    selectedEmployees: []
  }),
  components: {
    EmpLookup,
    CustomDatepicker,
    SeminarLookup,
    List,
    EmpSelection,
    EmpImage
  },
  computed: {
    ...mapState("config", ["docLinkConfig"]),
    attachmentUrl() {
      if (
        this.attachmentImage == null ||
        typeof this.attachmentImage == "undefined" ||
        this.attachmentImage == ""
      )
        return "";
      else return `data:image/jpeg;base64, ${this.attachmentImage}`;
    },
    showViewAttachment() {
      if (
        !isNullOrUndefined(this.docLinkConfig.isCustomFilePathEnableSemTrain)
      ) {
        return this.docLinkConfig.isCustomFilePathEnableSemTrain;
      } else return false;
    }
  },
  methods: {
    ...mapActions("config", ["getDocLinkConfig"]),
    save() {
      this.isSaving = true;
      if (this.formatType == "indi") {
        this.model.empCode = this.selectedEmp.code;
        this.model.semTitle = this.selectedSeminar.code;

        var formData = new FormData();
        var data = Object.assign({}, this.model);
        formData.append("json", JSON.stringify(data));
        formData.append("attachment", this.attachment);

        // this.$axios
        //   .post(`${API_ENDPOINT}`, this.model)
        this.$axios({
          method: "POST",
          url: `${API_ENDPOINT}`,
          data: formData,
          config: {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        })
          .then(({ data }) => {
            this.$toast.success(data.message);
            this.reset();
          })
          .catch(({ response }) => {
            this.$toast.error(response.data.message);
          })
          .finally(() => {
            this.isSaving = false;
          });
      } else if (this.formatType == "batch") {
        this.model.semTitle = this.selectedSeminar.code;
        var empCodeList = [];

        this.selectedEmployees.filter(item => {
          empCodeList.push(item.empCode);
        });

        var item = {
          Seminar: this.model,
          EmpCodeList: empCodeList
        };
        this.$axios
          .post(`${API_ENDPOINT}/batch`, item)
          .then(({ data }) => {
            this.$toast.success(data.message);
            this.reset();
            EventBus.$emit("CLEAR_EMPLOYEE");
          })
          .catch(({ response }) => {
            this.$toast.error(response.data.message);
          })
          .finally(() => {
            this.isSaving = false;
          });
      }
    },
    edit(item) {
      this.editDialog = true;
      if (item.timeTo != null) {
        item.timeTo = moment(item.timeTo).format("HH:mm");
      }
      if (item.timeFrom != null) {
        item.timeFrom = moment(item.timeFrom).format("HH:mm");
      }

      this.editModel = Object.assign({}, item);
      this.editSelectedSeminar = {
        code: item.semTitle,
        desc: item.semTitleDesc,
        semType: item.semType,
        semTypeDesc: item.semTypeDesc,
        semClass: item.semClass,
        semClassDesc: item.semClassDesc
      };
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.id}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    reset() {
      this.model = {};
      this.forceRerender();
      this.editDialog = false;
      this.selectedSeminar = {};
      this.selectedWritten = {};
      this.attachment = null;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    update() {
      this.isUpdating = true;

      //this.modeel.empCode = this.selectedEmp.code;
      this.editModel.semTitle = this.editSelectedSeminar.code;

      var formData = new FormData();
      var data = Object.assign({}, this.editModel);
      formData.append("json", JSON.stringify(data));
      formData.append("attachment", this.attachment);

      // this.$axios
      //   .post(`${API_ENDPOINT}`, this.model)
      this.$axios({
        method: "PUT",
        url: `${API_ENDPOINT}`,
        data: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      })
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },
    viewAttachment(item) {
      viewFileWithLocation(item.location);
    },
    openAttachment() {
      if (isNullOrUndefined(this.selectedEmp.code)) {
        this.$toast.error("No Employee selected.");
      } else {
        var newLink = this.docLinkConfig.filePathSemTrain.replace(
          "{EmpCode}",
          this.selectedEmp.code
        );
        window.open(newLink);
      }
    }
  },
  watch: {
    selectedEmp() {
      this.forceRerender();
    }
  },
  mounted() {
    EventBus.$on("SELECTED_EMPLOYEE", payload => {
      this.selectedEmployees = payload;
    });
  },
  created() {
    this.getDocLinkConfig();

    this.getUserAccessRights("EmpTrain");
  }
};
</script>
